var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useReducer } from "react";
import "./Lightcast.scss";
import translate from "src/i18n/translate";
import { sendRequest } from "src/common/http";
import WidgetLoader from "../common/elements/WidgetLoader";
import "@maptiler/sdk/dist/maptiler-sdk.css";
import * as maptilersdk from "@maptiler/sdk";
import ApiError from "../common/elements/ApiError";
var initialState = {
    regionalPopulation: null,
    loader: true
};
var defaultAction = {
    type: "",
    data: []
};
var reducer = function (state, action) {
    switch (action.type) {
        case "setPopulationByCounty":
            return __assign(__assign({}, state), { regionalPopulation: action.data, loader: false });
        case "setPopulationByCountyError":
            return __assign(__assign({}, state), { regionalPopulation: null, loader: false });
        default:
            return state;
    }
};
export default function InstitutionRegionContext(_a) {
    var regionalContext = _a.regionalContext, onComponentLoad = _a.onComponentLoad;
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    useEffect(function () {
        var applyResult = function (result) {
            dispatch({ type: "setPopulationByCounty", data: result });
            onComponentLoad("regionalContext");
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultAction), { type: "setPopulationByCountyError" }));
            onComponentLoad("regionalContext");
        };
        sendRequest({ uri: "/lightcast/population_by_county", camelize: true }, applyResult, onError);
    }, []);
    useEffect(function () {
        if (state.regionalPopulation && regionalContext) {
            generateRegionalMap(regionalContext.mapTilerApiKey, regionalContext.mapId, regionalContext.coordinates, state.regionalPopulation);
        }
        var regionalMapDiv = document.getElementById("regional-map");
        if (regionalMapDiv) {
            setTimeout(function () {
                regionalMapDiv.style.height = "460px";
            }, 2000);
        }
    }, [state.regionalPopulation, regionalContext]);
    return (_jsx("div", { className: "grid-container wm-grid-col-12 wm-grid-col-lg-12 wm-grid-col-md-10 wm-grid-col-sm-8", children: _jsxs("div", { className: "paper-card", children: [_jsx("div", { className: "header", children: _jsxs("div", { className: "info", children: [_jsx("h3", { className: "title", children: translate("app.institutionRegionContext.indusRegionContext") }), _jsx("div", { className: "description", children: translate("app.institutionRegionContext.reviewLastFive") })] }) }), _jsxs("div", { className: "body wm-grid", children: [!state.loader && regionalContext && state.regionalPopulation && (_jsx(Body, { regionalContext: regionalContext, regionalPopulation: state.regionalPopulation })), state.loader && (_jsx(WidgetLoader, { loaderContainerClasses: "loader", loaderClasses: "content" })), !state.loader && (!regionalContext || !state.regionalPopulation) && (_jsx(ApiError, {}))] })] }) }));
}
var Body = function (props) {
    var _a, _b, _c, _d;
    var regionalPopulation = props.regionalPopulation.filter(function (rp) {
        return rp.name !== "Total";
    });
    var totalRegionalPopulation = props.regionalPopulation.filter(function (rp) {
        return rp.name === "Total";
    });
    return (_jsxs("div", { className: "", children: [_jsx("div", { className: "institution-detail base-font-size", children: translate("app.lightcast.institutionDetails") }), _jsxs("div", { className: "body context-widget-labor-force", children: [_jsx("div", { className: "context-ipeds -detail", children: _jsxs("div", { className: "-detail-value", children: [_jsx("div", { className: "context-count", children: (_a = props.regionalContext) === null || _a === void 0 ? void 0 : _a.zip }), _jsx("div", { className: "context-label", children: translate("app.institutionRegionContext.institutionIPEDS") })] }) }), _jsx("div", { className: "context-detail -detail", children: _jsxs("div", { className: "-detail-value", children: [_jsxs("div", { className: "context-count", children: [(_b = props.regionalContext) === null || _b === void 0 ? void 0 : _b.radius, " mi"] }), _jsx("div", { className: "context-label", children: translate("app.institutionRegionContext.radiusZipCode") })] }) }), _jsx("div", { className: "context-detail -detail context-time-frame", children: _jsxs("div", { className: "-detail-value", children: [_jsx("div", { className: "context-count", children: (_c = props.regionalContext) === null || _c === void 0 ? void 0 : _c.timeFrame }), _jsx("div", { className: "context-label", children: translate("app.institutionRegionContext.fiveYear") })] }) }), _jsx("div", { className: "context-counties", children: _jsxs("div", { className: "-detail-value", children: [_jsx("div", { className: "context-count", children: (_d = props.regionalContext) === null || _d === void 0 ? void 0 : _d.noOfCounties }), _jsx("div", { className: "context-label", children: translate("app.institutionRegionContext.countiesIncluded") })] }) })] }), _jsxs("div", { className: "flex-row map-container", children: [_jsxs("div", { className: "map-wrap", children: [_jsx("div", { className: "-header county-map-header base-font-size", children: translate("app.lightcast.mapByCounty") }), _jsx("div", { id: "regional-map", className: "regional-map" }), _jsxs("div", { id: "legend", className: "overlay", children: [_jsx("h4", { className: "label-heading", children: translate("app.lightcast.countyByPopulation") }), _jsxs("div", { className: "labels", children: [_jsxs("div", { className: "flex-row -verticallycentered percentage-container", children: [_jsx("span", { className: "zero-percentage percentage-box" }), translate("app.lightcast.zero")] }), _jsxs("div", { className: "flex-row -verticallycentered percentage-container", children: [_jsx("span", { className: "twenty-percentage percentage-box" }), translate("app.lightcast.twenty")] }), _jsxs("div", { className: "flex-row -verticallycentered percentage-container", children: [_jsx("span", { className: "fourty-percentage percentage-box" }), translate("app.lightcast.fourty")] }), _jsxs("div", { className: "flex-row -verticallycentered percentage-container", children: [_jsx("span", { className: "sixty-percentage percentage-box" }), translate("app.lightcast.sixty")] }), _jsxs("div", { className: "flex-row -verticallycentered percentage-container", children: [_jsx("span", { className: "eighty-percentage percentage-box" }), translate("app.lightcast.eighty")] })] })] })] }), _jsxs("div", { className: "-context", children: [_jsx("div", { className: "-header county-map-header base-font-size", children: translate("app.institutionRegionContext.regionalPopulation") }), _jsx("div", { className: "table-container", children: _jsxs("table", { className: "data-table -shadow county-table county-table-labor-market", children: [_jsx("thead", { className: "dataheader", children: _jsxs("tr", { className: "dataheaderrow", children: [_jsx("th", { className: "dataheadercell", "data-th": "County", children: translate("app.institutionRegionContext.county") }), _jsx("th", { className: "dataheadercell", "data-th": "Population", children: translate("app.institutionRegionContext.population") }), _jsx("th", { className: "dataheadercell", "data-th": "Percentage", children: translate("app.institutionRegionContext.percentage") })] }) }), _jsx("tbody", { className: "databody county-table-body", tabIndex: 0, children: props.regionalPopulation &&
                                                regionalPopulation.map(function (rp) {
                                                    return (_jsxs("tr", { className: "datarow", children: [_jsx("td", { className: "datacell", children: rp === null || rp === void 0 ? void 0 : rp.name }), _jsx("td", { className: "datacell", children: rp === null || rp === void 0 ? void 0 : rp.population }), _jsxs("td", { className: "datacell", children: [rp === null || rp === void 0 ? void 0 : rp.percentage, "%"] })] }, rp === null || rp === void 0 ? void 0 : rp.name));
                                                }) }), _jsx("tfoot", { className: "footer-border", children: props.regionalPopulation &&
                                                totalRegionalPopulation.map(function (rp) {
                                                    return (_jsxs("tr", { className: "datarow", children: [_jsx("td", { className: "datacell", children: translate("app.institutionRegionContext.total") }), _jsx("td", { className: "datacell", children: rp === null || rp === void 0 ? void 0 : rp.population }), _jsxs("td", { className: "datacell", children: [rp === null || rp === void 0 ? void 0 : rp.percentage, "%"] })] }, rp === null || rp === void 0 ? void 0 : rp.name));
                                                }) })] }) })] })] })] }));
};
var generateRegionalMap = function (apiKey, mapId, coordinates, regionalPopulation) { return __awaiter(void 0, void 0, void 0, function () {
    function setStates() {
        var counties = map.querySourceFeatures("statesData", {
            sourceLayer: "administrative",
            filter: ["==", "level", 2]
        });
        counties.forEach(function (county) {
            var _a;
            var code = county.properties.code;
            if (county.id && vizData.get(code)) {
                map.setFeatureState({
                    source: "statesData",
                    sourceLayer: "administrative",
                    id: county.id
                }, {
                    percentage: (_a = vizData.get(code)) === null || _a === void 0 ? void 0 : _a.percentage
                });
            }
        });
        if (counties.length !== 0) {
            map.off("data", afterLoad);
        }
    }
    function afterLoad() {
        if (map.getSource("statesData") && map.isSourceLoaded("statesData")) {
            setStates();
        }
    }
    var mapContainer, map, layers, firstSymbolId, i, vizData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mapContainer = document.getElementById("regional-map");
                map = new maptilersdk.Map({
                    container: mapContainer,
                    style: "https://api.maptiler.com/maps/".concat(mapId, "/style.json"),
                    center: [coordinates.longitude, coordinates.latitude],
                    zoom: 5.5,
                    apiKey: apiKey
                });
                return [4 /*yield*/, map.onLoadAsync()];
            case 1:
                _a.sent();
                map.addSource("statesData", {
                    type: "vector",
                    url: "https://api.maptiler.com/tiles/countries/tiles.json"
                });
                layers = map.getStyle().layers;
                for (i = 0; i < layers.length; i++) {
                    if (layers[i].type === "symbol") {
                        firstSymbolId = layers[i].id;
                        break;
                    }
                }
                addCountiesLayer(map, firstSymbolId);
                vizData = new Map(regionalPopulation.map(function (county) { return [county.code, county]; }));
                map.on("click", "counties", function (e) {
                    var code = e.features[0].properties.code;
                    var county = vizData.get(code);
                    county &&
                        new maptilersdk.Popup()
                            .setLngLat(e.lngLat)
                            .setHTML("<h3 class=\"red\">".concat(county.population, "</h3><p>").concat(county.name, "</p>"))
                            .addTo(map);
                });
                if (map.isSourceLoaded("statesData")) {
                    setStates();
                }
                else {
                    map.on("sourcedata", afterLoad);
                }
                map.on("mousemove", "counties", function (e) {
                    var code = e.features[0].properties.code;
                    var county = vizData.get(code);
                    county
                        ? (map.getCanvas().style.cursor = "pointer")
                        : (map.getCanvas().style.cursor = "default");
                });
                map.on("sourcedata", function () {
                    map.getCanvas().style.cursor = "default";
                });
                return [2 /*return*/];
        }
    });
}); };
var addCountiesLayer = function (map, firstSymbolId) {
    map.addLayer({
        id: "counties",
        type: "fill",
        source: "statesData",
        "source-layer": "administrative",
        filter: ["==", "level", 2],
        paint: {
            "fill-color": [
                "case",
                ["!=", ["to-number", ["feature-state", "percentage"]], 0],
                [
                    "step",
                    ["feature-state", "percentage"],
                    "#E5ECF5",
                    20,
                    "#A4BDDE",
                    40,
                    "#3C76BB",
                    60,
                    "#275182",
                    80,
                    "#122A47"
                ],
                "rgba(0, 0, 0, 0)"
            ],
            "fill-opacity": 1,
            "fill-outline-color": "#000"
        }
    }, firstSymbolId);
};
